










































import Vue from 'vue';
import { pick } from 'lodash';
import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  components: {
    TopNav,
  },
  data() {
    return {
      logo: '/assets/images/integrations/mail-chimp@3x.png',
      emailProvidersInfo: null,
      mailChimpLists: null,
      mailchimpListIdSelected: null,
      isLoading: true,
      inProgress: false,
    };
  },
  methods: {
    async refreshMailchimp() {
      this.emailProvidersInfo = await this.$store.dispatch(
        'setting/getEmailProvider'
      );
      if (this.emailProvidersInfo?.mailchimp_api_key) {
        try {
          this.mailChimpLists = await this.$store.dispatch(
            'setting/getMailChimpLists'
          );

          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t(
              'SETTINGS.NOTIFICATIONS.MAILCHIMP_SUCCESSFULLY_UPDATED'
            ),
          });
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: errorToMessage(error.response),
          });
          await this.$store.dispatch('setting/updateEmailProviderInfo', {
            email_provider: null,
          });
        }
        const { mailchimp_list_id } = this.emailProvidersInfo;
        this.mailchimpListIdSelected = this.mailChimpLists?.lists?.find(
          list => list.id == mailchimp_list_id
        );
      }
    },
    async updateMailchimp() {
      this.inProgress = true;
      const data = pick(this.emailProvidersInfo, [
        'mailchimp_api_key',
        'mailchimp_list_id',
      ]);
      data.email_provider = 'mailchimp';

      try {
        await this.$store.dispatch('setting/updateEmailProviderInfo', data);
        await this.refreshMailchimp();
      } finally {
        this.inProgress = false;
      }
    },
    selectMailchimpList(list) {
      this.mailchimpListIdSelected = list;
      this.emailProvidersInfo.mailchimp_list_id = list?.id;
    },
    removeMailChimp() {
      console.log('removeMailChimp');
    },
  },
  async mounted() {
    await this.refreshMailchimp();
    this.isLoading = false;
  },
});
